import { render } from "./AlignmentSpecialist.vue?vue&type=template&id=7e759ba3&scoped=true"
import script from "./AlignmentSpecialist.vue?vue&type=script&lang=js"
export * from "./AlignmentSpecialist.vue?vue&type=script&lang=js"

import "./AlignmentSpecialist.vue?vue&type=style&index=0&id=7e759ba3&scoped=true&lang=css"

import exportComponent from "C:\\Users\\mraha\\Pictures\\tandzorggestel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e759ba3"]])

export default __exports__